import type { ReactNode } from "react";
import { cx } from "../lib/cx";

/**
 * Label-and-value pairs, the shape every drill panel and detail page uses.
 *
 * §11.3's typography: the label is the caption tone at 12px (the §4.2 floor for
 * Mongolian Cyrillic) and the value is body at 14. They are never the same
 * thing — the failure §11.3 names is a field's name and the note about it
 * reading as one two-line grey block.
 */
export function SummaryList({
  items,
  columns = 2,
}: {
  items: readonly { label: string; value: ReactNode; wide?: boolean }[];
  columns?: 1 | 2;
}) {
  return (
    <dl className={cx("grid gap-x-6 gap-y-3", columns === 2 ? "sm:grid-cols-2" : "grid-cols-1")}>
      {items.map((item) => (
        <div key={item.label} className={cx("flex min-w-0 flex-col gap-0.5", item.wide && "sm:col-span-2")}>
          <dt className="text-xs text-muted-foreground">{item.label}</dt>
          <dd className="min-w-0 text-sm text-foreground">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}

/** A money or count value: tabular, right-aligned where it sits in a column of others. */
export function Figure({ children, className }: { children: ReactNode; className?: string }) {
  return <span className={cx("tabular", className)}>{children}</span>;
}
